import { render, staticRenderFns } from "./PersonalDetailsModal.vue?vue&type=template&id=4cf2fc09&scoped=true"
import script from "./PersonalDetailsModal.vue?vue&type=script&lang=ts"
export * from "./PersonalDetailsModal.vue?vue&type=script&lang=ts"
import style0 from "./PersonalDetailsModal.vue?vue&type=style&index=0&id=4cf2fc09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf2fc09",
  null
  
)

export default component.exports